import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=00a07fda&scoped=true&lang=pug&"
import script from "./LazyImage.vue?vue&type=script&lang=js&"
export * from "./LazyImage.vue?vue&type=script&lang=js&"
import style0 from "./LazyImage.vue?vue&type=style&index=0&id=00a07fda&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a07fda",
  null
  
)

export default component.exports